export enum LoanType {
  None = 'NONE',
  Custom = 'CUSTOM',
  Instant = 'INSTANT',
  Otc = 'OTC',
}

export enum ChanceToMatch {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  VERY_HIGH = 'VERY_HIGH',
  NA = 'NA',
}
